<template>
  <Dialog
    :header="'Preview File -' + sectionFile"
    maximizable
    :style="{ width: '100rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    v-model:visible="isVisible"
    :closeOnEscape="false"
    :closable="false"
    :modal="true"
    @hide="hide()"
    @show="show()"
  >
    <div v-if="this.urlFile">
      <div v-if="this.isImg == true">
        <img
          :src="this.urlFile"
          alt="Image preview"
          style="width: 100%; height: 100%"
        />
      </div>
      <div v-if="this.isPdf == true" class="pdf-container">
        <object :data="this.urlFile" type="application/pdf"></object>
        <!-- <iframe
          :src="this.urlFile"
          type="application/pdf"
          width="100%"
          height="700px"
        /> -->
      </div>
    </div>
    <template #footer>
      <Button
        label="Download"
        icon="pi pi-download"
        class="pi-button p-button-success"
        @click="downloadData"
      />
      <Button
        label="Close"
        icon="pi pi-times"
        class="pi-button p-button-primary"
        @click="hide"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  data() {
    return {
      errMessage: null,
      modelPassword: null,
      disableButton: false,
      resetPassword: {
        currentPass: null,
        pass: null,
        confirmPass: null,
      },
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    urlFile: {
      type: String,
      default: "",
    },
    fileNames: {
      type: String,
      default: "",
    },
    sectionFile: {
      type: String,
      default: "",
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
    isImg: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      if (this.initialErrorMessage) {
        this.errMessage = this.initialErrorMessage;
      }
    },
    hide() {
      this.$emit("update:isVisible", false);
      this.$emit("hide");
    },
    downloadData() {
      const link = document.createElement("a");
      link.href = this.urlFile;
      link.setAttribute("download", this.fileNames);
      document.body.appendChild(link);
      link.click();

      // Bersihkan URL blob setelah digunakan
      document.body.removeChild(link);
      window.URL.revokeObjectURL(this.urlFile);
    },
  },
  emits: ["hide", "block-ui", "unblock-ui"],
};
</script>

<style #scoped>
.pdf-container {
  width: 100%;
  height: 0;
  padding-bottom: 75%; /* Menyesuaikan rasio aspek, misalnya 4:3 */
  position: relative;
}

.pdf-container object,
.pdf-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none; /* Menghilangkan border agar terlihat lebih bersih */
}

@media (max-width: 768px) {
  .pdf-container {
    height: 0;
    padding-bottom: 100%; /* Rasio aspek untuk layar lebih kecil */
  }
}
</style>
